<template>
  <component
    :is="filterUrl ? 'a' : 'div'"
    :style="skin"
    :href="fullUrl"
    :data-hover="lightOrDarkHover"
  >
    <slot>
      <span>
        <aw-icon v-if="selected" icon="filter-check" class="icon" :style="{ color: iconColor }" />
      </span>
      {{ filter.name }}
    </slot>
  </component>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterUrl: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fullUrl() {
      if (!this.filterUrl) return null

      const baseUrl = this.filter?.base_url?.url || '/'

      return baseUrl + '#ambiFilters=1&tags=' + this.filter.id
    },
    lightOrDarkHover() {
      const bgColor = this.skin?.['--bg-color']

      if (bgColor.toUpperCase() === '#000000') {
        return 'dark'
      }

      return 'light'
    },
    skin() {
      if (this.filter.bg_color === null) {
        return null
      }

      return {
        '--bg-color': this.filter.bg_color,
        '--text-color': this.filter.text_color || '#000',
        '--border-color': 'rgb(0 0 0 / 20%)'
      }
    },
    iconColor() {
      if (this.filter.bg_color.toUpperCase() === '#FFFFFF') {
        return '#C8102E'
      }

      return this.filter.text_color || '#000'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 1.05em;
  height: 1.05em;
}
</style>
